import { composeRouteGenerator } from '@app/modules/compose/routing/compose-route-generator';
import { BtnLink } from '@mi-front/ui';
import AddIcon from '@mui/icons-material/Add';
import { defineMessage, useIntl } from 'react-intl';

/** Shared intl message for entry points into the create-composition flow. */
export const composeCreateCompositionActionMessage = defineMessage({
  id: 'compose.createComposition.action',
  defaultMessage: 'Crear composición',
});

/**
 * Primary navigation control to open the create-composition flow for a station.
 */
export function ComposeCreateCompositionLink({ stationSlug }: { stationSlug: string }) {
  const { $t } = useIntl();

  return (
    <BtnLink
      type="link"
      to={composeRouteGenerator.createForStationSlug(stationSlug)}
      icon={<AddIcon />}
    >
      {$t(composeCreateCompositionActionMessage)}
    </BtnLink>
  );
}
